export const AccionDocumento = Object.freeze({
    LISTAR: "listar",
    VER: "ver",
    APROBAR: "aprobar",
    SUBIR: "subir",
    ANULAR: "anular",
    // RECHAZAR: "rechazar",
    DESCARGAR: "descargar"
});
